const colors = {
  grey: '#aaa',
  primary: {
    main: '#923158',
    light: '#b65b80',
    dark: '#6e1338'
  },
  // lighter: db92af
  secondary: {
    main: "#632870",
  },
  // alt secondary lighter: 80488c
}

export default colors
